import { createContext } from 'react';
import { AnonymousViewModel } from '@steelbuy/ts-shared';

import { defaultSearchDataValue, SearchDataProviderValue } from './SearchDataProviderValue';

export const createSearchDataContext = <Model extends AnonymousViewModel>(): React.Context<
    SearchDataProviderValue<Model>
> => createContext<SearchDataProviderValue<Model>>(defaultSearchDataValue);
